var map = {
	"./90BF486898ED4D84.png": "e67a",
	"./90BF486898ED4D85.png": "101d",
	"./AC1C6D93047DFE12.png": "a808",
	"./AC1C6D93047DFE16.png": "8b24",
	"./arrow-back.svg": "f632",
	"./arrow.svg": "3bb7",
	"./contact_icon.ai": "7d7f",
	"./contact_icon.svg": "cd43",
	"./dashboard_mymenus.svg": "fbb1",
	"./dashboard_myorders.svg": "aee7",
	"./email_icon.svg": "f1a2",
	"./facebook.svg": "8fd8",
	"./hilton_logo.png": "f33e",
	"./hilton_qr_menu.png": "3d92",
	"./homepage_banner_outlined_2.ai": "a5e1",
	"./homepage_banner_outlined_2.svg": "cfba",
	"./homepage_banner_outlined_2_extended.ai": "d534",
	"./homepage_banner_outlined_2_extended.svg": "fb4d",
	"./illo_menu_create.png": "a264",
	"./illo_menu_send.png": "aa51",
	"./instagram.svg": "b63c",
	"./logos/boardwalk.png": "2fd2",
	"./logos/cafedelmor.jpg": "1a03",
	"./logos/cafedelmor.png": "3711",
	"./logos/campagnia.png": "611f",
	"./logos/chocolatebar.png": "46d8",
	"./logos/edge.png": "2b03",
	"./logos/hilton.png": "ac51",
	"./logos/kantina.jpg": "9e3d",
	"./logos/kantina.png": "ca17",
	"./logos/kayumanis.png": "26ef",
	"./logos/mamalous.jpg": "55cd",
	"./logos/mamalous.png": "e54e",
	"./logos/mireio.png": "58dc",
	"./logos/mumtaz.png": "2125",
	"./logos/palace.jpg": "5ffd",
	"./logos/palace.png": "d8af",
	"./logos/shire.jpg": "b4f0",
	"./logos/shire.png": "3100",
	"./logos/silversands.png": "6b40",
	"./logos/woodlands.png": "b707",
	"./mamalous_logo.png": "3e6a",
	"./mamalous_qr_menu.png": "f9f4",
	"./menu_create.svg": "51ca",
	"./menu_create_icon_only.png": "8a08",
	"./menu_create_icon_only.svg": "078d",
	"./menu_send.png": "36a1",
	"./menubuilder.ai": "1b2e",
	"./menubuilder.svg": "c1b2",
	"./menubuilder2.ai": "7d57",
	"./menubuilder2.svg": "f39c",
	"./menulingua_logo_v2-01.svg": "c4dc",
	"./menulingua_logomark_v2-02.svg": "0a2e",
	"./pattern_withoutbackgr-dark.png": "9ac0",
	"./pattern_withoutbackgr-dark_resized.png": "71d9",
	"./quotes.svg": "99c5",
	"./quotes_white.svg": "ea10",
	"./sign-in-icon.svg": "475f",
	"./telegram-logo.svg": "2a2c",
	"./whatsapp.svg": "38ed",
	"./x_mark_white.svg": "0bc8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc97";